"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USE_VALUE = exports.MODIFIER_DELIMITER = exports.ELEMENT_DELIMITER = exports.BLOCK_DELIMITER = void 0;
exports.BLOCK_DELIMITER = '-';
exports.ELEMENT_DELIMITER = '__';
exports.MODIFIER_DELIMITER = '--';
exports.USE_VALUE = 'USE_VALUE';
//# sourceMappingURL=constants.js.map